// 页面翻译汇总
import login from "./login/index.js";
import largesrceen from "./largesrceen/index.js";
import help from "./help/index.js";
import caseHandlingTool from "./caseHandlingTool/index.js";
import datacase from "./datacase/index.js";
import personalinfo from "./personalinfo.js";
import feedback from "./feedback/index.js";
import monitor from "./monitor/index.js";
import model from "./model/index.js";
import balance from "./balance/index.js";

import home from "./home/index.js";
import label from "./label/index.js";
import adjustment from "./adjustment/index.js";
import caseModule from "./case/index.js";
import historylist from "./historylist/index.js";
import canvas from "./canvas/index.js";
import details from "./details/index.js";
import aiChat from "./AI/aiChat.js";

export default {
  login,
  largesrceen,
  home,
  label,
  adjustment,
  case: caseModule,
  historylist,
  canvas,
  help,
  caseHandlingTool,
  datacase,
  personalinfo,
  feedback,
  monitor,
  model,
  balance,
  label,
  details,
  aiChat,
};
